import React, { useState } from "react";
import {
  Container,
  Tabs,
  Tab,
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { CodeBlock, dracula } from "react-code-blocks";
import { layoutCSS } from "../component/common/commonStyle";
const apiData = [
  {
    label: "Send SMS",
    url: "http://sms.xcelmarketing.in/api/SmsApi/SendSingleApi",
    parameters: [
      { name: "UserID", description: "Customer User ID" },
      { name: "Password", description: "Customer Password" },
      { name: "SenderID", description: "Sender ID" },
      { name: "phno", description: "Phone Number" },
      { name: "Msg", description: "Message Content" },
      { name: "EntityID", description: "Entity ID" },
      { name: "TemplateID", description: "Template ID" },
    ],
    response: `{
      "Response": {
          "Data": [{
              "TransDate": "04-02-2020 15:44:25 PM",
              "Result": "DELIVRD",
              "SenderID": "OTPOTP"
          }]
      },
      "Status": "OK"
    }`,
  },
  {
    label: "Balance",
    url: "http://sms.xcelmarketing.in/api/SmsApi/CheckBalance",
    parameters: [
      { name: "UserID", description: "Customer User ID" },
      { name: "Password", description: "Customer Password" },
    ],
    response: `{
      "Response": {
          "Balance": 99364
      },
      "Status": "OK"
    }`,
  },
  {
    label: "SenderID List",
    url: "http://sms.xcelmarketing.in/api/SmsApi/GetSenderID",
    parameters: [
      { name: "UserID", description: "Customer User ID" },
      { name: "Password", description: "Customer Password" },
    ],
    response: `{
      "Response": {
          "SenderIds": ["VJTEST", "AVLBLE", "PRSHNT"]
      },
      "Status": "OK"
    }`,
  },
];

export default function ApiDocumentation() {
  const [value, setValue] = useState(0);

  return (
    <Box sx={layoutCSS}>
      <Tabs
        value={value}
        onChange={(e, newValue) => setValue(newValue)}
        indicatorColor="primary"
        textColor="primary"
        sx={{ "& .MuiTab-root": { fontSize: "0.75rem" } }}
      >
        {apiData.map((api, index) => (
          <Tab key={index} label={api.label} />
        ))}
      </Tabs>

      {apiData.map((api, index) => (
        <Box key={index} role="tabpanel" hidden={value !== index} p={2}>
          {value === index && (
            <>
              <Typography variant="h6" gutterBottom sx={{ fontSize: "0.8rem" }}>
                API URL:
              </Typography>
              <Paper elevation={2} sx={{ p: 2, mb: 2 }}>
                <Typography variant="body2" sx={{ fontSize: "0.75rem" }}>
                  {api.url}
                </Typography>
              </Paper>

              <Typography variant="h6" gutterBottom sx={{ fontSize: "0.8rem" }}>
                Parameters:
              </Typography>
              <TableContainer component={Paper}>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ fontSize: "0.75rem" }}>
                        <b>Parameter Name</b>
                      </TableCell>
                      <TableCell sx={{ fontSize: "0.75rem" }}>
                        <b>Description</b>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {api.parameters.map((param, idx) => (
                      <TableRow key={idx}>
                        <TableCell sx={{ fontSize: "0.75rem" }}>
                          {param.name}
                        </TableCell>
                        <TableCell sx={{ fontSize: "0.75rem" }}>
                          {param.description}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

              <Typography
                variant="h6"
                gutterBottom
                sx={{ mt: 2, fontSize: "0.8rem" }}
              >
                Example Response:
              </Typography>
              <Box sx={{ fontSize: "0.7rem" }}>
                <CodeBlock
                  text={api.response}
                  language="json"
                  theme={dracula}
                />
              </Box>
            </>
          )}
        </Box>
      ))}
    </Box>
  );
}
